export type ApiErrorLanguage = 'ko' | 'ja';

export interface ApiErrorMessages {
  errorGeneric: string;
  errorUnauthorized: string;
  errorForbidden: string;
  errorNetwork: string;
  errorConflict: string;
  errorNotFound: string;
  errorInvalidJson: string;
}

export function formatApiError(
  code: string | undefined,
  messages: ApiErrorMessages
): string {
  switch (code) {
    case 'unauthorized':
      return messages.errorUnauthorized;
    case 'Forbidden':
    case 'forbidden':
      return messages.errorForbidden;
    case 'invalid_json':
      return messages.errorInvalidJson;
    case 'conflict':
      return messages.errorConflict;
    case 'not_found':
      return messages.errorNotFound;
    default:
      return code && code.length > 0 && !code.includes('must be')
        ? code
        : messages.errorGeneric;
  }
}

export async function readApiError(
  response: Response,
  messages: ApiErrorMessages
): Promise<string> {
  if (!response.ok) {
    try {
      const body = (await response.json()) as { error?: string };
      return formatApiError(body.error, messages);
    } catch {
      return messages.errorNetwork;
    }
  }

  return messages.errorGeneric;
}
